import { render, staticRenderFns } from "./UadForm.vue?vue&type=template&id=28ba5bf3&"
import script from "./UadForm.vue?vue&type=script&lang=js&"
export * from "./UadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports